<template>
  <section>
    <div class="container">
      <div class="grid row">
        <div class="g-col-3">
          <post-filters
            :filters="filters"
            @update-filters="getPosts"
          ></post-filters>
        </div>
        <div class="g-col-9">
          <post-grid :posts="posts" class_name="post-index-grid"></post-grid>
          <div>
            <button
              class="btn"
              @click="getLoadMorePosts"
              v-if="page !== totalpages"
            >
              load more
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, reactive } from "vue";
import PostFilters from "./PostFilters.vue";
import PostGrid from "./PostGrid.vue";

export default {
  components: {
    PostFilters,
    PostGrid,
  },
  setup() {
    let filters = reactive({ list: [] });
    let posts = reactive({ list: [] });
    let page = ref(0);
    let totalpages = ref(-1);

    let post_type;
    let term_query;
    let ppp = 3;
    const pageID = document.querySelector("body").dataset.id;

    /**
     * Fetch
     */
    function getData(url) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then((response) => {
            return response.json();
          })
          .then((data) => resolve(data))
          .catch((error) => reject(error));
      });
    }

    /**
     * Get filters (taxonomy and terms)
     */
    getData(`/wp-json/api/get-index-page/?id=${pageID}`).then((data) => {
      data.results.filters.forEach((filter) => {
        const terms = filter.terms;
        terms.forEach((term) => {
          term.selected = false;
        });
      });

      filters.list = data.results.filters;
      post_type = data.results.post_type;

      // initial call to get posts
      getData(`/wp-json/api/get-posts/?post_type=${post_type}&ppp=${ppp}`).then(
        (data) => {
          page.value = 1;
          totalpages.value = data.results.totalpages;
          posts.list = data.results.posts;
        }
      );
    });

    /**
     * get posts by filter selection
     */
    const getPosts = (v) => {
      term_query = "";

      filters.list.forEach((item) => {
        const selected_terms = [];

        item.terms.forEach((term) => {
          if (term.term_id === v.term_id) term.selected = v.selected;
          if (term.selected) selected_terms.push(term.term_id);
        });

        if (selected_terms.length > 0) {
          term_query += `&${item.taxonomy}=${selected_terms.toString()}`;
        }
      });

      getData(
        `/wp-json/api/get-posts/?post_type=${post_type}${term_query}&ppp=${ppp}`
      ).then((data) => {
        page.value = 1;
        totalpages.value = data.results.totalpages;
        posts.list = data.results.posts;
      });
    };

    /**
     * get posts by load more button
     */
    const getLoadMorePosts = () => {
      getData(
        `/wp-json/api/get-posts/?post_type=${post_type}${
          term_query ? term_query : ""
        }&ppp=${ppp}&page=${page.value + 1}`
      ).then((data) => {
        page.value++;
        posts.list = posts.list.concat(data.results.posts);
      });
    };

    return { filters, posts, page, totalpages, getPosts, getLoadMorePosts };
  },
};
</script>
